import React from 'react'
import { useTranslation } from 'react-i18next';
import { Row, Col, Button, FormGroup, Label, InputGroup, InputGroupText, Card, CardBody, CardTitle, CardText } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Field } from 'react-final-form';
import { DatePicker } from 'react-widgets';
import Icon from '@mdi/react';
import { mdiCashSync, mdiReceiptTextEditOutline } from '@mdi/js';

import './InvoiceListItem.css';

export default ({ invoice, actions, editable, className, condensed }) => {
    const { t } = useTranslation();

    if (!invoice)
        return null;

    if (condensed)
        className = (className || '') + ' condensed';

    const color = React.useMemo(() => {
        return invoice.due === 0 ? 'success' : (invoice.due > 0 ? 'warning' : 'danger');
    }, [invoice]);

    const renderDateTimePicker = ({ input: { onChange, value }, showTime }) =>
        <DatePicker
            onChange={onChange}
            format="DD MMM YYYY"
            includeTime={showTime}
            value={!value ? null : new Date(value)}
        />
    return (
        <Card className={ `InvoiceListItem ${className}` }>
            <CardBody>
                <Row className="mb-0">
                    <Col className="col-auto bg-primary">
                        <CardText>
                            <Icon path={ mdiCashSync } size={1} color="white" />&nbsp;
                        </CardText>
                    </Col>
                    <Col>
                        <CardText className="px-3">
                            {!editable && invoice.created_at.format('LL') }
                            {editable && (
                                <FormGroup>
                                    <Label tag="strong">{t('invoices.created_at')}</Label>
                                    <Field
                                        showTime={false}
                                        component={renderDateTimePicker}
                                        className="form-control"
                                        type="text"
                                        name="created_at"
                                        id="created_at"
                                        autoComplete=""
                                    />
                                </FormGroup>
                            )}
                        </CardText>
                    </Col>
                    <Col>
                        <CardText className="px-3">
                            {!editable && (
                                <strong>{t('invoices.total')} : {invoice.formatAmount() }</strong>
                            )}
                            {editable && (
                                <FormGroup>
                                    <Label tag="strong">{t('invoices.total')}</Label>
                                    <InputGroup>
                                        <Field className="form-control" component="input" type="number" step={0.01} name="amount" />
                                        <InputGroupText>€</InputGroupText>
                                    </InputGroup>
                                </FormGroup>
                            )}
                        </CardText>
                    </Col>
                    <Col className={`bg-${color} d-flex justify-content-center align-items-center`}>
                        <CardText>
                            <h3>{t('invoices.due')} : { invoice.formatDue() }</h3>
                        </CardText>
                    </Col>
                    { !editable && (
                    <Col className="col-auto">
                        <div className="actions">
                            <Button tag={Link} to={ `/invoices/edit/${ invoice.id }` } color="warning" size="sm">
                                <Icon path={ mdiReceiptTextEditOutline } size={1} color="#000000" />&nbsp;
                            </Button>
                        </div>
                    </Col>
                    )}
                </Row>
            </CardBody>
        </Card>
    )
}
